import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
    headers: { "Content-Type": "application/json" },
});

export async function submitEnquiry(payload) {
    const { data } = await api.post("/enquiries", payload);
    return data;
}

export async function getOptions() {
    const { data } = await api.get("/config/options");
    return data;
}

export async function healthCheck() {
    const { data } = await api.get("/health");
    return data;
}
